<template>
  <div>
  <modal-emitir-certificados ref="modalEmitirCertificados" @certificadosEmitidos="listarCertificados"/>

    <div class="tab-pane fade show active" id="pills-notificacoes" role="tabpanel" aria-labelledby="pills-notificacoes-tab">
      <div>
        <a href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="modalEmitirCertificados()"><i class="fas fa-plus"></i> Emitir Certificados</a>&#32;
      </div>
    </div>
   </div>
</template>

<script>
import ModalEmitirCertificados from '@/modules/Certificados/components/ModalEmitirCertificados'

export default {
  name: 'ListaCertificados',
  components: { ModalEmitirCertificados },

  data () {
    return {
    }
  },

  mounted () {
  },

  methods: {
    modalEmitirCertificados: function () {
      this.$nextTick(() => {
        this.$refs.modalEmitirCertificados.show()
      })
    },
    listarCertificados: function () {
    }

  }

}
</script>
